// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topTileview{
  margin: 15.8px 30px !important;
  border-radius: 0px !important;

}

.topTileview .tile .title{
  font-size: 14px;
  font-weight: 800;
  -webkit-animation: reverse;
  -webkit-animation-delay: 0s;
  -webkit-animation-direction: alternate;
}

.topTileview .tile .subtitle{
  font-size: 13px;
  color: #ccc;
}

.topTileview .tile .tileViewFooter{
  min-height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/staff-room/topic-details/topic-tile-view/topic-tile-view.component.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,6BAA6B;;AAE/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf","sourcesContent":[".topTileview{\n  margin: 15.8px 30px !important;\n  border-radius: 0px !important;\n\n}\n\n.topTileview .tile .title{\n  font-size: 14px;\n  font-weight: 800;\n  -webkit-animation: reverse;\n  -webkit-animation-delay: 0s;\n  -webkit-animation-direction: alternate;\n}\n\n.topTileview .tile .subtitle{\n  font-size: 13px;\n  color: #ccc;\n}\n\n.topTileview .tile .tileViewFooter{\n  min-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
